const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
};

export const calculateSwimSetMeters = (set = {}) => {
    const reps = toNumber(set.reps) || 1;
    return reps * toNumber(set.distance);
};

export const calculateSwimBlockMeters = (block = {}) =>
    (block.sets || []).reduce((total, set) => total + calculateSwimSetMeters(set), 0);

export const calculateSwimSessionMeters = (session = {}) =>
    (session.blocks || []).reduce((total, block) => total + calculateSwimBlockMeters(block), 0);

export const calculateSwimTemplateMeters = (template = {}) =>
    (template.sessions || template.workouts || []).reduce(
        (total, session) => total + calculateSwimSessionMeters(session),
        0
    );

export const getSwimIntensityDistribution = (sets = []) => {
    const totalMeters = sets.reduce((total, set) => total + calculateSwimSetMeters(set), 0);
    const distribution = sets.reduce((acc, set) => {
        const zone = set.intensity || "Sem zona";
        const meters = calculateSwimSetMeters(set);
        acc[zone] = (acc[zone] || 0) + meters;
        return acc;
    }, {});

    return Object.entries(distribution)
        .map(([zone, meters]) => ({
            zone,
            meters,
            percent: totalMeters > 0 ? Math.round((meters / totalMeters) * 100) : 0,
        }))
        .sort((a, b) => b.meters - a.meters);
};
